export const PartsData = [
  {
    id: 1,
    title: "drive",
    handle: "/parts/drive",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Parts_1_Powertrain.jpg",
    youtube: "",
    content: `Дэлхий даяар бүх төрлийн ажлын талбарт Cat тоног төхөөрөмжүүд нь захын дамжуулагч болон хурдны хайрцгийн тусламжтайгаар хүч дамжуулж урагш хөдлөн, газар шорооны ажил хийдэг.

Caterpillar-ын оригинал хүч дамжуулах эд ангийн сэлбэгүүдийг тогтмол засвар үйлчилгээ, засварын хувилбаруудтай хамтад нь ашигласнаар тоног төхөөрөмжийн бүтээмжийг хамгийн өндөр түвшинд хүргэж, ашиглалтын зардлыг бууруулах боломжтой.

Cat хүч дамжуулах эд анги нь дараах ачааллыг тэсвэрлэх чадвартай хийгдсэн байдаг:

Их хэмжээний мушгих момент

Цохилт ихтэй хөрсөн дээр ажиллах

Хөдөлгөөний чиглэл болон арааг олон дахин солих г.м

Катерпиллар нь эдгээр хэрэгцээ шаардлагыг бүрэн хангасан хурдны хайрцаг, захын дамжуулагчийг зохион бүтээж үйлдвэрлэдэг ба бодит ажлын талбартай ижилхэн нөхцөлд туршилтад оруулж тестлэдэг. Үүний үр дүнд тоног төхөөрөмжийн насжилтын хугацаанд удаан ашиглагдаж, илүү сайн ажиллах хүч дамжуулах эд анги бий болдог.  

  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/drivetrain.png)  
  

**ХҮЧ ДАМЖУУЛАХ АНГИ:**

Холхивч

Тоормос

Дифференциал

Кардан Гол

Захын Дамжуулагч

Үрэлтийн Материал

Гидротрансформатор

Хурдны Хайрцаг  
  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/drivetrain2.png)`,
    content_en: `Дэлхий даяар бүх төрлийн ажлын талбарт Cat тоног төхөөрөмжүүд нь захын дамжуулагч болон хурдны хайрцгийн тусламжтайгаар хүч дамжуулж урагш хөдлөн, газар шорооны ажил хийдэг.

Caterpillar-ын оригинал хүч дамжуулах эд ангийн сэлбэгүүдийг тогтмол засвар үйлчилгээ, засварын хувилбаруудтай хамтад нь ашигласнаар тоног төхөөрөмжийн бүтээмжийг хамгийн өндөр түвшинд хүргэж, ашиглалтын зардлыг бууруулах боломжтой.

Cat хүч дамжуулах эд анги нь дараах ачааллыг тэсвэрлэх чадвартай хийгдсэн байдаг:

Их хэмжээний мушгих момент

Цохилт ихтэй хөрсөн дээр ажиллах

Хөдөлгөөний чиглэл болон арааг олон дахин солих г.м

Катерпиллар нь эдгээр хэрэгцээ шаардлагыг бүрэн хангасан хурдны хайрцаг, захын дамжуулагчийг зохион бүтээж үйлдвэрлэдэг ба бодит ажлын талбартай ижилхэн нөхцөлд туршилтад оруулж тестлэдэг. Үүний үр дүнд тоног төхөөрөмжийн насжилтын хугацаанд удаан ашиглагдаж, илүү сайн ажиллах хүч дамжуулах эд анги бий болдог.  

  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/drivetrain.png)  
  

**ХҮЧ ДАМЖУУЛАХ АНГИ:**

Холхивч

Тоормос

Дифференциал

Кардан Гол

Захын Дамжуулагч

Үрэлтийн Материал

Гидротрансформатор

Хурдны Хайрцаг  
  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/drivetrain2.png)`,
  },
  {
    id: 2,
    title: "undercarriage",
    handle: "/parts/undercarriage",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Parts_2_GET.jpg",
    youtube:
      '<iframe width="1020" height="590" src="https://www.youtube.com/embed/JIcqePEw138?wmode=transparent" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>',
    content: `Катерпиллар® нь 100 гаруй жилийн турш гинжит явах эд анги бүхий машины сэлбэг хэрэгслийг зохион бүтээж, үйлдвэрлэж ирсэн. Бид таны машиныг ямар нөхцөлд илүү бүтээмжтэй, үр ашигтай ажиллуулахыг сайн мэднэ.

Хамгийн чухал зүйл нь явах ангидаа хэрхэн хөрөнгө оруулалахаас шалтгаалж машины бүтээл байж болох хамгийн дээд түвшинд хүрч ажиллах ба бид үүнийг л танд зөвлөх үүрэгтэй. Гинжит машиныг эзэмших болон ашиглах зардлын 50% нь явах ангийн зардлаас хамаардаг гэж үзвэл хамгийн их үнэ цэнэтэй зөвлөгөөг бид таны системд зориулан хүргэх учиртай юм.

Бид таны санхүүгийн байдал болон ажлын шаардлагад нийцүүлэн явах ангийг хэд хэдэн төрлөөр санал болгож байна.

Таны машины болон ажлын сонголт тус бүр өөрийн гэсэн нөлөөтэй байдаг. Таны гүйцэтгэх ажил болон боломжуудыг судалж, тухайн нөхцөлд тань зориулж хамгийн сайн бүтээмж, удаан эдэлгээ болон үнэ цэнэ бүхий сонголт хийхэд тань бид тусална.

Та явах ангиа хэр зэрэг нарийвчлалтай тохируулан сонгох тусам таны ажил төдий чинээ үр дүнтэй, байх болно. Иймээс бид бусад ямар ч үйлдвэрлэгчдээс илүү олон төрлийн явах ангийн сонголтыг Cat® машинууддаа санал болгодог.

Бидний санал болгож буй явах ангийн сэлбэг бүрийг Катерпиллар компанийн мэргэжлийн инженерүүд зохион бүтээсэн бөгөөд үйлчлүүлэгчдийнхээ бодит туршлага дээр үндэслэн нарийвчилсан үзүүлэлтүүдийн дагуу үйлдвэрлэсэн. Тиймээс, та Кат явах ангийг сонгохдоо энэ нь зүгээр нэг зөв сонголт ч биш, хамгийн шилдэг сонголт гэдэгт итгэлтэй байж болно.

  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/Undercarriage.png)

**Бидэнтэй зөвлөлдөөрэй!**

  

Манай мэргэжилтнүүд таны явах ангид тусгай багаж хэрэгсэл болон програм ашиглан хэмжилт, үзлэгийг үнэ төлбөргүй хийж, үүн дээрээсээ үндэслэн зөв тохиргоо, засвар болон дараагийн сонголтыг тань ямар байхад зөвлөж туслах болно. Тиймээс та явах ангидаа аль сонголт тохирох болохыг манай бүтээгдэхүүн дэмжих хэлтсийн мэргэжилтнүүдтэй зөвлөлдөөрэй.  
  

**Cat явах ангийн үнэгүй үзлэгээ захиал!**

  

7018-7588  

**  
Явах ангийн элэгдлийг хэрхэн удирдах вэ****?  
**`,
    content_en: `Катерпиллар® нь 100 гаруй жилийн турш гинжит явах эд анги бүхий машины сэлбэг хэрэгслийг зохион бүтээж, үйлдвэрлэж ирсэн. Бид таны машиныг ямар нөхцөлд илүү бүтээмжтэй, үр ашигтай ажиллуулахыг сайн мэднэ.

Хамгийн чухал зүйл нь явах ангидаа хэрхэн хөрөнгө оруулалахаас шалтгаалж машины бүтээл байж болох хамгийн дээд түвшинд хүрч ажиллах ба бид үүнийг л танд зөвлөх үүрэгтэй. Гинжит машиныг эзэмших болон ашиглах зардлын 50% нь явах ангийн зардлаас хамаардаг гэж үзвэл хамгийн их үнэ цэнэтэй зөвлөгөөг бид таны системд зориулан хүргэх учиртай юм.

Бид таны санхүүгийн байдал болон ажлын шаардлагад нийцүүлэн явах ангийг хэд хэдэн төрлөөр санал болгож байна.

Таны машины болон ажлын сонголт тус бүр өөрийн гэсэн нөлөөтэй байдаг. Таны гүйцэтгэх ажил болон боломжуудыг судалж, тухайн нөхцөлд тань зориулж хамгийн сайн бүтээмж, удаан эдэлгээ болон үнэ цэнэ бүхий сонголт хийхэд тань бид тусална.

Та явах ангиа хэр зэрэг нарийвчлалтай тохируулан сонгох тусам таны ажил төдий чинээ үр дүнтэй, байх болно. Иймээс бид бусад ямар ч үйлдвэрлэгчдээс илүү олон төрлийн явах ангийн сонголтыг Cat® машинууддаа санал болгодог.

Бидний санал болгож буй явах ангийн сэлбэг бүрийг Катерпиллар компанийн мэргэжлийн инженерүүд зохион бүтээсэн бөгөөд үйлчлүүлэгчдийнхээ бодит туршлага дээр үндэслэн нарийвчилсан үзүүлэлтүүдийн дагуу үйлдвэрлэсэн. Тиймээс, та Кат явах ангийг сонгохдоо энэ нь зүгээр нэг зөв сонголт ч биш, хамгийн шилдэг сонголт гэдэгт итгэлтэй байж болно.

  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/Undercarriage.png)

**Бидэнтэй зөвлөлдөөрэй!**

  

Манай мэргэжилтнүүд таны явах ангид тусгай багаж хэрэгсэл болон програм ашиглан хэмжилт, үзлэгийг үнэ төлбөргүй хийж, үүн дээрээсээ үндэслэн зөв тохиргоо, засвар болон дараагийн сонголтыг тань ямар байхад зөвлөж туслах болно. Тиймээс та явах ангидаа аль сонголт тохирох болохыг манай бүтээгдэхүүн дэмжих хэлтсийн мэргэжилтнүүдтэй зөвлөлдөөрэй.  
  

**Cat явах ангийн үнэгүй үзлэгээ захиал!**

  

7018-7588  

**  
Явах ангийн элэгдлийг хэрхэн удирдах вэ****?  
**`,
  },
  {
    id: 3,
    title: "engine",
    handle: "/parts/engine",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Parts_3_Engine.jpg",
    youtube:
      '<iframe width="1020" height="590" src="https://www.youtube.com/embed/afTprU56Yag?wmode=transparent" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>',
    content: `**ХӨДӨЛГҮҮРИЙН АЖИЛЛАГААГ САЙЖРУУЛАХ ОРИГИНАЛ, ЧАНАРТАЙ СЭЛБЭГ**

  

Хөдөлгүүрийн сэлбэгүүд нь өндөр даралт, температурын эрс тэс нөхцлийг ч тэсвэрлэж, доголдолгүй ажиллах шаардлагатай байдаг. Ийм ч учраас Катерпиллар нь сэлбэгийн загвар болон сэлбэг үйлдвэрлэлийн үе шатуудад тасралтгүй сайжруулт хийсээр байдаг.

Cat® хөдөлгүүрийн эд ангиуд нийлээд цогц систем болон ажилладаг ба эдэлгээний төгсгөлд их засвар хийлгэснээр дахин ашиглагдах боломжтой.

Cat хөдөлгүүрийг бусад брендийн бүтээгдэхүүнтэй харьцуулсан олон удаагийн туршилтын үр дүнд Cat сэлбэгийн бусдаас ялгарах давуу тал нь  батлагдсан байдаг. Үүнд:

Хөдөлгүүрийн ажиллагаа сайжирна

Тоног төхөөрөмжийн бүтээл нэмэгдэнэ

Тоног төхөөрөмжийн ашиглалтын зардал буурна

  

**КАТЕРПИЛЛАРЫН ОРИГИНАЛ СЭЛБЭГ:**

  

Цилиндрийн гавал

Тахир гол

Жийрэг, сальник

Хавхлаг

Поршен ба поршенгийн цагираг

Гилз

Холхивч

Шатун

Радиатор

Термостат

Усны насос

Очлуур

Турбо

Түлшний инжектор

Cat сэлбэгүүд нь Cat хөдөлгүүрт төгс таарч ажиллахаар бүтээгдсэн ба үнэдээ тохирсон чанарыг санал болгодог. Үүгээр зогсохгүй, Cat сэлбэгт л байдаг, бусад брэндүүд санал болгож чадахгүй  нэг зүйл нь - Катерпилларын албан ёсны дилерээр дамжуулж баталгаат бүтээгдэхүүн дэмжих үйлчилгээ авах боломж юм.`,
    content_en: `**ХӨДӨЛГҮҮРИЙН АЖИЛЛАГААГ САЙЖРУУЛАХ ОРИГИНАЛ, ЧАНАРТАЙ СЭЛБЭГ**

  

Хөдөлгүүрийн сэлбэгүүд нь өндөр даралт, температурын эрс тэс нөхцлийг ч тэсвэрлэж, доголдолгүй ажиллах шаардлагатай байдаг. Ийм ч учраас Катерпиллар нь сэлбэгийн загвар болон сэлбэг үйлдвэрлэлийн үе шатуудад тасралтгүй сайжруулт хийсээр байдаг.

Cat® хөдөлгүүрийн эд ангиуд нийлээд цогц систем болон ажилладаг ба эдэлгээний төгсгөлд их засвар хийлгэснээр дахин ашиглагдах боломжтой.

Cat хөдөлгүүрийг бусад брендийн бүтээгдэхүүнтэй харьцуулсан олон удаагийн туршилтын үр дүнд Cat сэлбэгийн бусдаас ялгарах давуу тал нь  батлагдсан байдаг. Үүнд:

Хөдөлгүүрийн ажиллагаа сайжирна

Тоног төхөөрөмжийн бүтээл нэмэгдэнэ

Тоног төхөөрөмжийн ашиглалтын зардал буурна

  

**КАТЕРПИЛЛАРЫН ОРИГИНАЛ СЭЛБЭГ:**

  

Цилиндрийн гавал

Тахир гол

Жийрэг, сальник

Хавхлаг

Поршен ба поршенгийн цагираг

Гилз

Холхивч

Шатун

Радиатор

Термостат

Усны насос

Очлуур

Турбо

Түлшний инжектор

Cat сэлбэгүүд нь Cat хөдөлгүүрт төгс таарч ажиллахаар бүтээгдсэн ба үнэдээ тохирсон чанарыг санал болгодог. Үүгээр зогсохгүй, Cat сэлбэгт л байдаг, бусад брэндүүд санал болгож чадахгүй  нэг зүйл нь - Катерпилларын албан ёсны дилерээр дамжуулж баталгаат бүтээгдэхүүн дэмжих үйлчилгээ авах боломж юм.`,
  },
  {
    id: 4,
    title: "filters",
    handle: "/parts/filters",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Parts_4_GET.jpg",
    youtube:
      '<iframe width="1020" height="590" src="https://www.youtube.com/embed/QI0MrzP1gbA?wmode=transparent" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>',
    content: `**ШИНГЭН**

**CAT® ШИНГЭН ӨӨР ҮР ДҮН ҮЗҮҮЛЭХЭЭР БҮТЭЭГДСЭН**

Cat® шингэнийг нүдээр хараад бусад шингэнээс өөр гэдгийг мэдэх боломжгүй ч ашиглалтын дараах үр дүнгээс ялгаа нь илт мэдэгддэг. Системүүд бохирдолгүй байснаар тоног төхөөрөмжийн ажиллагаа сайжирч, эд ангиудын эдэлгээ уртасна.

Cat шингэний ялгаа хоёр зүйл дээр тод илэрдэг. Нэгдүгээрт, Cat шингэн нь бусад ямар ч шингэнтэй харьцуулшгүй өндөр стандартын дагуу, Cat системийн салшгүй хэсэг байхаар зохион бүтээгдсэн. Хоёрдугаарт, таны тоног төхөөрөмжийн эдэлгээ болон ажиллагаанд бодит нөлөө үзүүлнэ.

Cat тос нь эд анги зэврэхээс сэргийлж, гадаргууд тортог үүсгэхгүйгээр хамгаалдаг ба хэвийн зунгаг чанараа тогтвортой хадгалахаар бүтээгдсэн байдаг учир агрегатын элэгдлийг хамгийн бага байлгадаг.

Cat шингэний зууралдах чанар нь бусад шингэнээс илүү сайн байдаг ба тоног төхөөрөмжийг тасралтгүй хамгаалсаар байдаг.

Ердийн тосыг гурван удаа солих хугацаанд Cat шингэнийг нэг л удаа сольдог нь лабораторийн шинжилгээ болон хэрэглэгчдийн туршлагаар нотлогдсоор байна. Иймд та өөрийн тоног төхөөрөмждөө Cat шингэнийг хэрэглээд, бодит үр дүнг нь мэдрээрэй.`,
    content_en: `**ШИНГЭН**

**CAT® ШИНГЭН ӨӨР ҮР ДҮН ҮЗҮҮЛЭХЭЭР БҮТЭЭГДСЭН**

Cat® шингэнийг нүдээр хараад бусад шингэнээс өөр гэдгийг мэдэх боломжгүй ч ашиглалтын дараах үр дүнгээс ялгаа нь илт мэдэгддэг. Системүүд бохирдолгүй байснаар тоног төхөөрөмжийн ажиллагаа сайжирч, эд ангиудын эдэлгээ уртасна.

Cat шингэний ялгаа хоёр зүйл дээр тод илэрдэг. Нэгдүгээрт, Cat шингэн нь бусад ямар ч шингэнтэй харьцуулшгүй өндөр стандартын дагуу, Cat системийн салшгүй хэсэг байхаар зохион бүтээгдсэн. Хоёрдугаарт, таны тоног төхөөрөмжийн эдэлгээ болон ажиллагаанд бодит нөлөө үзүүлнэ.

Cat тос нь эд анги зэврэхээс сэргийлж, гадаргууд тортог үүсгэхгүйгээр хамгаалдаг ба хэвийн зунгаг чанараа тогтвортой хадгалахаар бүтээгдсэн байдаг учир агрегатын элэгдлийг хамгийн бага байлгадаг.

Cat шингэний зууралдах чанар нь бусад шингэнээс илүү сайн байдаг ба тоног төхөөрөмжийг тасралтгүй хамгаалсаар байдаг.

Ердийн тосыг гурван удаа солих хугацаанд Cat шингэнийг нэг л удаа сольдог нь лабораторийн шинжилгээ болон хэрэглэгчдийн туршлагаар нотлогдсоор байна. Иймд та өөрийн тоног төхөөрөмждөө Cat шингэнийг хэрэглээд, бодит үр дүнг нь мэдрээрэй.`,
  },
  {
    id: 5,
    title: "ground",
    handle: "/parts/ground",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Parts_5_FiltersFluids.jpg",
    youtube:
      '<iframe width="1020" height="590" src="https://www.youtube.com/embed/uRXCGFesvDk?wmode=transparent" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>',
    content: `

### ГАЗАРТАЙ ХАРЬЦАХ ЭД АНГИ

**ХЭРЭГЛЭЭНДЭЭ ТОХИРУУЛ**

*   Тоног төхөөрөмжийнхөө үнэтэй эд ангиудыг хамгаал
*   Тоног Төхөөрөмж ашиглалтын зардлаа бууруул
*   Тоног төхөөрөмжөө бүрэн хүчин чадлаар нь ажиллуул

Аливаа тоног төхөөрөмжийн хамгийн чухал хэсэг нь ажлын багаж юм. Шанага, хутга, адаптер, ир, соёо буюу тоног төхөөрөмжийн үндсэн ажлын багаж болох газартай харьцах эд анги (ГХЭА) нь тухайн тоног төхөөрөмжийн ашиглалт, зориулалтыг шууд тодорхойлдог.

ГХЭА нь тоног төхөөрөмжийн ажиллагаанд шууд нөлөө үзүүлдэг. ГХЭА-ийг буруу сонгох нь бүтээлд нөлөөлөөд зогсохгүй шатахуун зарцуулалт, засвар үйлчилгээний болон олборлолтын тонн тутмын зардлууд нэмэгдэж, тоног төхөөрөмжийн ашиглалтын хугацаа багасах нөлөөтэй.  

Caterpillar нь бүтээмжийг хамгийн өндөрт түвшинд хүргэх тусгай зориулалтын ГХЭА-ийн сонголтуудыг санал болгодог ба бид ашиглалтын зардал, засвар үйлчилгээний зардлыг хамгийн бага түвшинд байлгах, үр дүнтэй сонголт хийхэд тань туслах болно.

Бид таньд хэрэгцээ шаардлагад тань нийцсэн, бат бөх, элэгдэл багатай, тонн тутамд хамгийн бага өртгөөр олборлолт хийх сонголтуудыг санал болгож байна.

  
![](https://www.barloworld.mn/images/GET.png)

  
Газартай харьцах эд ангийг зөв сонгох нь ажлын бүтээмж, ашигт чухал нөлөө үзүүлдэг. Тиймээс Вагнер Ази Тоног Төхөөрөмж компани нь ажлын талбайн нөхцөл, хэрэглээний тусгай шаардлагыг хангасан, таны тоног төхөөрөмжид тохирох олон сонголтуудыг санал болгож байна. Газартай харьцах эд ангийг хэрэглээндээ тааруулан зөв сонгож тоног төхөөрөмжийн бүтээмжээ нэмэгдүүлээрэй.

Шанага, хутга, адаптер, ир, соёо зэрэг танд хэрэгтэй бүх л Cat газартай харьцах эд анги нь сайн чанарын гангаар, тусгай загвараар хийгдсэн байдаг. Үр дүнд нь суурилуулж, салгахад хялбар, нэврэлт сайтай хирнээ удаан эдэлгээтэй болдог.

Уул уурхай, барилга, хөдөө аж ахуй эрхлэгч нар нь Cat газартай харьцах эд ангийн найдвартай ажиллагаанд итгэл төгс байдаг. Учир нь Cat ГХЭА нь машины их биед гэмтэл учрахаас сэргийлээд зогсохгүй машины элэгдлийг багасгах зэрэг олон давуу талтай. Эдгээр давуу талуудаас нэмж дурдвал:

  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/GET1.png)  

`,
    content_en: `

### ГАЗАРТАЙ ХАРЬЦАХ ЭД АНГИ

**ХЭРЭГЛЭЭНДЭЭ ТОХИРУУЛ**

*   Тоног төхөөрөмжийнхөө үнэтэй эд ангиудыг хамгаал
*   Тоног Төхөөрөмж ашиглалтын зардлаа бууруул
*   Тоног төхөөрөмжөө бүрэн хүчин чадлаар нь ажиллуул

Аливаа тоног төхөөрөмжийн хамгийн чухал хэсэг нь ажлын багаж юм. Шанага, хутга, адаптер, ир, соёо буюу тоног төхөөрөмжийн үндсэн ажлын багаж болох газартай харьцах эд анги (ГХЭА) нь тухайн тоног төхөөрөмжийн ашиглалт, зориулалтыг шууд тодорхойлдог.

ГХЭА нь тоног төхөөрөмжийн ажиллагаанд шууд нөлөө үзүүлдэг. ГХЭА-ийг буруу сонгох нь бүтээлд нөлөөлөөд зогсохгүй шатахуун зарцуулалт, засвар үйлчилгээний болон олборлолтын тонн тутмын зардлууд нэмэгдэж, тоног төхөөрөмжийн ашиглалтын хугацаа багасах нөлөөтэй.  

Caterpillar нь бүтээмжийг хамгийн өндөрт түвшинд хүргэх тусгай зориулалтын ГХЭА-ийн сонголтуудыг санал болгодог ба бид ашиглалтын зардал, засвар үйлчилгээний зардлыг хамгийн бага түвшинд байлгах, үр дүнтэй сонголт хийхэд тань туслах болно.

Бид таньд хэрэгцээ шаардлагад тань нийцсэн, бат бөх, элэгдэл багатай, тонн тутамд хамгийн бага өртгөөр олборлолт хийх сонголтуудыг санал болгож байна.

  
![](https://www.barloworld.mn/images/GET.png)

  
Газартай харьцах эд ангийг зөв сонгох нь ажлын бүтээмж, ашигт чухал нөлөө үзүүлдэг. Тиймээс Вагнер Ази Тоног Төхөөрөмж компани нь ажлын талбайн нөхцөл, хэрэглээний тусгай шаардлагыг хангасан, таны тоног төхөөрөмжид тохирох олон сонголтуудыг санал болгож байна. Газартай харьцах эд ангийг хэрэглээндээ тааруулан зөв сонгож тоног төхөөрөмжийн бүтээмжээ нэмэгдүүлээрэй.

Шанага, хутга, адаптер, ир, соёо зэрэг танд хэрэгтэй бүх л Cat газартай харьцах эд анги нь сайн чанарын гангаар, тусгай загвараар хийгдсэн байдаг. Үр дүнд нь суурилуулж, салгахад хялбар, нэврэлт сайтай хирнээ удаан эдэлгээтэй болдог.

Уул уурхай, барилга, хөдөө аж ахуй эрхлэгч нар нь Cat газартай харьцах эд ангийн найдвартай ажиллагаанд итгэл төгс байдаг. Учир нь Cat ГХЭА нь машины их биед гэмтэл учрахаас сэргийлээд зогсохгүй машины элэгдлийг багасгах зэрэг олон давуу талтай. Эдгээр давуу талуудаас нэмж дурдвал:

  
![](https://d3leeb4r1qy96s.cloudfront.net/assets/img/parts/GET1.png)  

`,
  },
  {
    id: 1,
    title: "online",
    handle: "https://parts.cat.com/en/catcorp",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Parts_6_PCC.jpg",
    content: `<></>`,
  },
];
